/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ProcessSummary } from '../../types/processing-schemas.ts';
import { ReactNode } from 'react';
import { Tag } from 'primereact/tag';
import { DataTableColumns } from '../TableHeader.tsx';
import { CopyText } from '../CopyText.tsx';

const jobControlBodyRender = ({ jobControlOptions }: ProcessSummary): ReactNode => {
  return (
    <div className="flex justify-content-center">
      {jobControlOptions?.map((el, idx) => (
        <Tag key={idx} severity="warning" value={el} />
      ))}
    </div>
  );
};

const keywordBodyRender = ({ keywords }: ProcessSummary): ReactNode => {
  return (
    <div className="flex align-items-center">
      {keywords?.map((el, idx) => (
        <Tag className="m-1" key={idx} severity="secondary" value={el} />
      ))}
    </div>
  );
};

export const defaultProcessDatableColumns: DataTableColumns[] = [
  {
    order: 0,
    field: 'id',
    header: 'ID',
    body: ({ id }) => {
      return <CopyText text={id} />;
    }
  },
  { order: 1, field: 'title', header: 'Title', sortable: true },
  {
    order: 2,
    field: 'description',
    header: 'Description',
    style: { width: '35%' },
    body: ({ description }) => {
      const LENGTH = 200;
      return description?.length > LENGTH ? description.slice(0, LENGTH).concat('...') : description;
    }
  },
  {
    order: 3,
    field: 'jobControlOptions',
    header: 'Job Control Options',
    align: 'center',
    sortable: true,
    body: jobControlBodyRender
  },
  { order: 4, field: 'keywords', header: 'Keywords', body: keywordBodyRender },
  { order: 5, field: 'version', header: 'Version', align: 'center' }
];
